import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function PleasureDeparture() {
  const dateTexts = ['1941年'];
  const title = 'メリウェザー・アダム・プレジャーが海へ旅立つ';
  const description = (
    <>
      {'S.E.A.会員の'}
      <a href='/merriweather-adam-pleasure'>
        {'メリウェザー・アダム・プレジャー'}
      </a>
      {'が新たな航海へと出発し、そのまま行方不明となる。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
    />
  );
}

export default PleasureDeparture;
